enum AdviceStatus {
  ACCEPTED = 'ACCEPTED',
  PENDING = 'PENDING',
  REFUSED = 'REFUSED',
}

export default AdviceStatus;
